import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useForm } from "react-hook-form";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { pages } from '../../site-config'

const BlogSubscribeForm = ({ pageUrl, pageTitle, title = "Subscribe", description = null, buttonText = "Subscribe", successMessage = "Thank you for subscribing to our insights." }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [state, setState] = useState({
    isSubmitted: false,
    isError: false
  });

  useEffect(() => {
    ReactRecaptcha3.init('6Lf8Y-ogAAAAAHK0AtJ6H4DN-KvX3gbgewzgF8bW').then(status => {
      // status: success/error
      // success - script is loaded and greaptcha is ready
      // error - script is not loaded
    });
  }, []);

  const onSubmit = (data) => {
    ReactRecaptcha3.getToken().then(token => {
      fetch('https://us-central1-outsmart-production.cloudfunctions.net/subscribe', {
        method: 'POST',
        body: JSON.stringify({ ...data, token, page: pageUrl, title: pageTitle }),
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        setState({
          isSubmitted: true,
        });
      })
      .catch(err => {
        setState({
          isError: true,
        });
      });
    }, error => {
      setState({
        isError: true,
      });
    })
  }

  return (
    <div className="c-article__subscribe">
      <div className="c-article__subscribe-title" id="share-label">{title}</div>
      {description ? <p className="c-article__subscribe-summary">{description}</p> : null}
      {!state.isSubmitted ?
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="c-contact__form-fields">
            <div className="c-contact__form-field">
              <div className="c-form__textbox-field">
                <label htmlFor="email" className="c-form__label">Email</label>
                <input id="email" name="email" placeholder="Email" className={errors.contactemail ? "c-form__textbox error" : "c-form__textbox"} {...register("email", { required: true, pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/ })} />
                {errors.email && <div className="c-form__validation c-form__validation--error"><p>Please enter a valid email</p></div>}
              </div>
              <br />
              <div className="c-contact__form-field">
                <p className="c-contact__form-consent">By clicking the 'Subscribe' button you're confirming that you agree with our following <Link to={pages.privacyPolicy}>Privacy Policy</Link>.</p>
              </div>
              <div className="c-contact__form-field">
                <input type="submit" value={buttonText} className="c-contact__submit c-btn c-btn--large c-btn--primary" />
              </div>
            </div>
          </div>
          {state.isError ? <p className="c-contact__summary">Unfortunately, your submission could not be sent. Please try again later.</p> : null}
        </form>
        : <p className="c-contact__summary">{successMessage}</p>}
    </div>
  )
}

export default BlogSubscribeForm
